import embeds, { ON } from "../data/js/embeds";
import GoogleAnalyticsTag from "./embed-tags/google-analytics";
import GooglePlacesTag from "./embed-tags/google-places";
import FacebookPixelTag from "./embed-tags/facebook-pixel";
import FacebookConnectTag from "./embed-tags/facebook-connect";
import GoogleReCaptchaTag from "./embed-tags/google-recaptcha";
import AppleSignInScript from "./embed-tags/apple-signin";
import GoogleSigninTag from "./embed-tags/google-signin";
import OneTrustTag from "./embed-tags/onetrust";
import AudigentTag from "./embed-tags/audigent";
import PlaywireTag from "./embed-tags/playwire";
import LotameTag from "./embed-tags/lotame";
import IntercomChatTag from "./embed-tags/intercom-chat";
import { SellwildDisplayAdsTag } from "./embed-tags/sellwild-display-ads";

// This file should contain every active 3rd party <script/> embed for the whole site.
// This file should NOT be edited to turn on/off embeds.
// Use data/js/embeds.js file to turn on/off each embed individually
// Or turn off all together via ALL. Only edit this file to add/delete embeds.

// Helper to decide if something should be OFF or ON
const isOn = (key: string, subGroup: string, exclude: readonly string[]) => {
	return (
		!exclude.includes(key) &&
		embeds.ALL === ON &&
		(subGroup === "" || embeds[subGroup] === ON) &&
		embeds[key] === ON
	);
};

/**
 * Left out on /dash. Admin tabs stay open for hours, and these are tracking
 * and address scripts the dash never uses. Sign-in scripts (reCAPTCHA,
 * Facebook, Apple) stay: a session that expires on a dash page signs in
 * again there, and the login bot gate needs reCAPTCHA.
 */
export const DASH_EXCLUDED_EMBEDS: readonly string[] = ["OneTrust", "GoogleAnalytics", "FacebookPixel", "GooglePlaces", "Lotame", "Audigent", "Playwire", "IntercomChat"];

export const Embeds = ({ exclude = [] }: { exclude?: readonly string[] }) => {
	return (
		<>
			{isOn("OneTrust", "TRACK", exclude) ? <OneTrustTag /> : null}
			{isOn("Lotame", "TRACK", exclude) ? <LotameTag /> : null}
			{isOn("IntercomChat", "APIS", exclude) ? <IntercomChatTag /> : null}
			{isOn("GoogleAnalytics", "TRACK", exclude) ? <GoogleAnalyticsTag /> : null}
			{isOn("GoogleReCaptcha", "SIGNIN", exclude) ? <GoogleReCaptchaTag /> : null}
			{isOn("GoogleSignin", "SIGNIN", exclude) ? <GoogleSigninTag /> : null}
			{isOn("GooglePlaces", "APIS", exclude) ? <GooglePlacesTag /> : null}
			{isOn("Playwire", "ADS", exclude) ? <PlaywireTag /> : null}
			{isOn("FacebookConnect", "SIGNIN", exclude) ? <FacebookConnectTag /> : null}
			{isOn("Audigent", "ADS", exclude) ? <AudigentTag /> : null}
			{isOn("FacebookPixel", "TRACK", exclude) ? <FacebookPixelTag /> : null}
			{isOn("AppleSignIn", "SIGNIN", exclude) ? <AppleSignInScript /> : null}
			{/* Loads the sellwild-ad custom-element hydrator. Script is small
			    and inert on pages with no <sellwild-ad> tags, so it can run
			    unconditionally rather than under the ADS gate (which is OFF
			    in dev and blocks hydration on native iOS). */}
			<SellwildDisplayAdsTag />
		</>
	);
};
